<template>
  <div class="account">
    <GlobalInfoBar :title="planId ? '编辑会员方案' : '新增会员方案'" />
    <GlobalChunk :padding="[20, 20, 20, 20]">

      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="135px" style="width: 80%;">
        <el-form-item label="方案名称" prop="plan_title">
          <el-input v-model="ruleForm.plan_title" maxlength="15" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="卡面" prop="face_img">
          <el-radio-group v-model="ruleForm.face_img" style="display: flex; justify-content: center; flex-wrap: wrap;">
            <div style="margin: 15px; text-align: center;" v-for="(ite, ind) of cardImgs" :key="ind">
              <div style="height: 90px; display: flex; align-items: center; justify-content: center;">
                <img :src="ite.url" alt="" style="max-height: 100%; max-width: 100%; object-fit: contain;">
              </div>
              <el-radio :label="ite.id" style="margin-top: 10px;">{{ '' }}</el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="售价" prop="plan_price">
          <el-input-number @change="planPriceChang" v-model="ruleForm.plan_price" :min="1"
            :max="10000"></el-input-number>
        </el-form-item>
        <el-form-item label="卡面显示分期方案" prop="plan_model">
          <el-checkbox-group v-model="ruleForm.plan_model">
            <el-checkbox label="日付"></el-checkbox>
            <el-checkbox label="月付"></el-checkbox>
            <el-checkbox label="一次性付" disabled></el-checkbox>
          </el-checkbox-group>
          <span style="color: red;font-size: 11px;">默认显示一次性付不可取消，日付和月付勾选后，店员开通会员时可选择不同的方案展示给顾客</span>
        </el-form-item>
        <el-form-item label="日付方案" v-if="ruleForm.plan_model.includes('日付')">
          <div style="display: flex;">
            <div>每日</div>
            <el-input v-model="ruleForm.price_day" style="margin: 0 15px;width: 100px;"
              @input="priceDayChage"></el-input>
            <div>元，共计</div>
            <el-input v-model="ruleForm.num_day" style="width: 30%;margin: 0 15px;" :disabled="true"></el-input>
            <div>天</div>
          </div>
        </el-form-item>
        <el-form-item label="月付方案" v-if="ruleForm.plan_model.includes('月付')">
          <div style="display: flex;">
            <div>每月</div>
            <el-input @input="priceMonthChage" v-model="ruleForm.price_month"
              style="margin: 0 15px;width: 100px;"></el-input>
            <div>元，共计</div>
            <el-input v-model="ruleForm.num_month" style="width: 30%;margin: 0 15px;" :disabled="true"></el-input>
            <div>月</div>
          </div>
        </el-form-item>
        <el-form-item label="面储值额" prop="stored_type">
          <el-radio-group v-model="ruleForm.stored_type">
            <el-radio :label="1">等于售价</el-radio>
            <el-radio :label="2">自定义储值额</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="储值额" prop="stored_value">
          <el-input-number :disabled="ruleForm.stored_type == 1" v-model="ruleForm.stored_value" :min="1"
            :max="10000"></el-input-number> 元
        </el-form-item>
        <el-form-item label="包含权益">
          <div style="display: flex;justify-content: space-between;padding: 15px;">
            <span>此处选择本会员方案包含的权益</span>
            <el-button type="primary" @click="add('interests')">选择权益</el-button>
          </div>
          <el-table :data="ruleForm.interests_arr" style="width: 100%">
            <el-table-column type="index" label="序号" align="center">
            </el-table-column>
            <el-table-column prop="interest_name" label="权益名称" align="center">
            </el-table-column>
            <el-table-column prop="interest_content" label="权益内容" align="center">
            </el-table-column>
            <el-table-column prop="address" label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="interestsDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="配置赠送商品">
          <div style="display: flex;justify-content: space-between;padding: 15px;">
            <span>配置后，店员只需要选择会员方案，自动选择方案对应的商品；不配置则需店员自行选择</span>
            <el-button type="primary" @click="add('gifts')">选择商品</el-button>
          </div>

          <el-table :data="ruleForm.goods_arr" style="width: 100%">
            <el-table-column type="index" label="序号" align="center">
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="goods_price" label="商品零售价（元）" align="center">
            </el-table-column>
            <el-table-column prop="goods_num" label="数量" align="center">
            </el-table-column>
            <el-table-column prop="address" label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="giftsDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          合计：{{ goods_all_price }}元

        </el-form-item>
        <el-form-item label="会员规则说明" prop="plan_explain">
          <vue-editor v-model="ruleForm.plan_explain" />
        </el-form-item>
        <el-form-item>
          <div style="display: flex;justify-content: end;">
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          </div>
        </el-form-item>
      </el-form>

      <el-dialog :title="addType == 'interests' ? '选择权益' : '选择商品'" :visible.sync="dialogVisible" width="60%">
        <div style="display: flex;width: 300px;align-items: center;margin: 15px;">
          <div style="width: 130px;">{{ addType == 'interests' ? '权益' : '商品' }}名称</div>
          <el-input v-model="search" style="margin: 0 15px;" clearable></el-input>
          <el-button type="primary" @click="query()">查询</el-button>
        </div>
        <!-- <div style="display: flex;justify-content: end;align-items: center; margin: 15px;">
          <span>若当前无您想要的商品，可点击新增{{ addType == 'interests' ? '权益' : '商品' }}</span>
          <el-button @click="addElem" type="primary" style="margin-left: 5px;" icon="el-icon-plus">{{ addType ==
            'interests' ?
            '添加权益' :
            '添加商品'
          }}</el-button>
        </div> -->
        <el-table :data="dialogTableData" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column type="index" label="序号" align="center">
          </el-table-column>
          <el-table-column :prop="addType == 'interests' ? 'interest_name' : 'goods_name'"
            :label="addType == 'interests' ? '权益名称' : '商品名称'" align="center">
          </el-table-column>
          <el-table-column :prop="addType == 'interests' ? 'interest_content' : 'goods_price'"
            :label="addType == 'interests' ? '权益内容' : '商品零售价'" align="center">
          </el-table-column>
        </el-table>
        <div style="display: flex;justify-content: end;margin: 15px;">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="10"
            layout="prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogSubmit()">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog :title="addType == 'interests' ? '新增权益' : '新增商品'" :visible.sync="elemDialogShow" width="500px"
        :before-close="elemDialogClose">

        <el-form v-if="addType == 'interests'" ref="interestsForm" :model="interestsForm" label-width="100px"
          size="small" :rules="interestsRules">
          <el-form-item prop="interest_name" label="权益名称">
            <el-input v-model="interestsForm.interest_name" placeholder="请输入权益名称" maxlength="30" show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item prop="interest_content" label="权益内容">
            <div class="price-input">
              <el-input v-model="interestsForm.interest_content" type="textarea" :autosize="{ minRows: 3, maxRows: 5 }"
                placeholder="请输入权益内容" maxlength="80" show-word-limit>
              </el-input>
            </div>
          </el-form-item>

          <div class="form-footer">
            <el-button size="small" @click="elemDialogClose()">取消</el-button>
            <el-button type="primary" size="small" @click="interestsConfirm">确定</el-button>
          </div>
        </el-form>

        <el-form v-else ref="goodsForm" :model="goodsForm" label-width="100px" size="small" :rules="goodsRules">
          <el-form-item prop="goods_name" label="商品名称">
            <el-input v-model="goodsForm.goods_name" placeholder="请输入商品名称" maxlength="30" show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item prop="goods_price" label="商品零售价">
            <div class="price-input">
              <el-input-number v-model="goodsForm.goods_price" :controls-position="'right'" :min="1" :max="10000">
              </el-input-number>
              <span class="unit">元/个</span>
            </div>
          </el-form-item>
          <div class="form-footer">
            <el-button size="small" @click="elemDialogClose()">取消</el-button>
            <el-button type="primary" size="small" @click="goodsConfirm">确定</el-button>
          </div>
        </el-form>
      </el-dialog>
    </GlobalChunk>

  </div>
</template>

<script>
import { CardImgs, planInfo, goodsList, goodsSet, interestsList, interestsSet, planSet } from "@/utils/request/memberBackendManagement";
import { VueEditor } from 'vue2-editor';


export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      planId: null,
      cardImgs: [],
      ruleForm: {
        plan_model: ['一次性付'],
        interests_arr: [],
        goods_arr: [],
        price_month: 0,
        num_month: '',
        price_day: 0,
        num_day: ''
      },
      rules: {
        plan_title: [
          { required: true, message: '请输入方案名称', trigger: 'blur' },
        ],
        face_img: [
          { required: true, message: '请选择卡面', trigger: 'change' }
        ],
        plan_price: [
          { required: true, message: '请输入售价', trigger: 'blur' },
        ],
        plan_model: [
          { type: 'array', required: true, message: '请至少选择一个卡面显示分期方案', trigger: 'change' }
        ],
        stored_type: [
          { required: true, message: '请选择面储值额', trigger: 'change' }
        ],
        stored_value: [
          { required: true, message: '请输入储值额', trigger: 'blur' },
        ],
        plan_explain: [
          { required: true, message: '请填写会员规则说明', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      dialogTableData: [],
      currentPage: 1,
      total: 0,
      search: '',
      addType: '',
      elemDialogShow: false,
      interestsForm: {
      },
      interestsRules: {
        interest_name: [{ required: true, message: '请输入权益名称', trigger: 'blur' },
        ],
        interest_content: [{ required: true, message: '请输入权益内容', trigger: 'blur' },
        ],
      },
      goodsForm: {
      },
      goodsRules: {
        goods_name: [{ required: true, message: '请输入商品名称', trigger: 'blur' },
        { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        goods_price: [{ required: true, message: '请输入商品零售价', trigger: 'blur' },
        ],
      },
      goods_all_price: 0,

    }

  },
  watch: {
    // 'ruleForm.plan_price'(newVal, oldVal) {
    //   console.log(1, newVal);


    // },
    // 'ruleForm.price_day'(newVal, oldVal) {
    //   console.log(2, newVal);

    // },
    // 'ruleForm.price_month'(newVal, oldVal) {
    //   console.log(3, newVal);

    // },
    'ruleForm.stored_type'(newVal, oldVal) {
      console.log(4, newVal);
      if (newVal == 1) {
        this.ruleForm.stored_value = this.ruleForm.plan_price
      }
    },
    'ruleForm.plan_model'(newVal, oldVal) {
      console.log(5, newVal);
      if (!newVal.includes('月付')) {
        this.ruleForm.price_month = 0
        this.ruleForm.num_month = ''
      }
      if (!newVal.includes('日付')) {
        this.ruleForm.price_day = 0
        this.ruleForm.num_day = ''
      }
    },
    'dialogVisible'(newVal, oldVal) {
      console.log(6, newVal);
      this.search = ''
    }
  },
  mounted() {
    const { plan_id } = this.$route.query
    this.planId = plan_id;
    if (plan_id) {
      planInfo({ plan_id }).then(res => {
        console.log(111, res);
        res.data.plan_model = res.data.plan_model.split(',');
        this.ruleForm = res.data
        this.goods_all_price = this.ruleForm.goods_arr.reduce((sum, item) => sum + (item.goods_num * (Number(item.goods_price))), 0);

      })
    }
    CardImgs().then(res => {

      this.cardImgs = res.data
    })
  },
  methods: {
    planPriceChang(e) {
      console.log(e, 11111111);

      const { price_day, price_month } = this.ruleForm

      if (price_day != 0 && price_month != 0) {
        console.log(222);
        // 使用 this.$set 确保响应式更新
        this.$set(this.ruleForm, 'num_day', Math.ceil(e / price_day));
        this.$set(this.ruleForm, 'num_month', Math.ceil(e / price_month));
      } else {
        console.log(333);

        this.ruleForm.num_day = ''
        this.ruleForm.num_month = ''
      }
    },
    priceDayChage(e) {
      console.log('ccc', e);
      if (e != 0) {
        this.ruleForm.num_day = Math.ceil(this.ruleForm.plan_price / e)
      } else {
        this.ruleForm.num_day = ''
      }
    },
    priceMonthChage(e) {
      console.log(e);
      if (e != 0) {
        this.ruleForm.num_month = Math.ceil(this.ruleForm.plan_price / e)

      } else {
        this.ruleForm.num_month = ''
      }
    },
    interestsDelete(index) {
      this.ruleForm.interests_arr.splice(index, 1)
    },
    giftsDelete(index) {
      this.ruleForm.goods_arr.splice(index, 1)
      this.goods_all_price = this.ruleForm.goods_arr.reduce((sum, item) => sum + (item.goods_num * (Number(item.goods_price))), 0);

    },
    add(type) {
      this.addType = type
      this.dialogVisible = true
      this.getTableData()
    },
    getTableData() {
      this.dialogTableData = []
      if (this.addType == 'interests') {
        interestsList({
          page: this.currentPage,
          is_open: 1
        }).then(res => {
          this.dialogTableData = res.data
          this.total = res.count

        })
      } else {
        goodsList({
          page: this.currentPage,
          is_open: 1
        }).then(res => {
          this.dialogTableData = res.data
          this.total = res.count

        })
      }
    },
    query() {
      this.dialogTableData = []
      if (this.addType == 'interests') {
        const interest_name = this.search
        interestsList({
          page: this.currentPage,
          is_open: 1,
          interest_name
        }).then(res => {
          this.dialogTableData = res.data
        })
      } else {
        const goods_name = this.search
        goodsList({
          page: this.currentPage,
          is_open: 1,
          goods_name
        }).then(res => {
          this.dialogTableData = res.data
        })
      }
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getTableData()
    },
    addElem() {
      this.handleSelection = []
      this.elemDialogShow = true
    },
    interestsConfirm() {
      this.$refs.interestsForm.validate(valid => {
        if (!valid) return
        interestsSet(this.interestsForm).then(res => {
          this.$message.success(res.msg)
          this.elemDialogShow = false
          this.$refs['interestsForm'].resetFields();
          this.interestsForm = {}
          this.getTableData()
        }).catch(err => {
        })
      })
    },
    goodsConfirm() {
      this.$refs.goodsForm.validate(valid => {
        if (!valid) return
        goodsSet(this.goodsForm).then(res => {
          this.$message.success(res.msg)
          this.elemDialogShow = false
          this.$refs['goodsForm'].resetFields();
          this.goodsForm = {}
          this.getTableData()
        }).catch(err => {
        })
      })
    },
    elemDialogClose() {
      this.elemDialogShow = false
      this.getTableData()
    },
    handleSelectionChange(val) {
      this.handleSelection = val
    },
    dialogSubmit() {
      console.log('this.handleSelection', this.handleSelection);

      if (this.addType == 'interests') {
        this.ruleForm.interests_arr.push(...this.handleSelection)
      } else {
        this.handleSelection.map((ele) => {
          ele.goods_num = 1
        })
        this.ruleForm.goods_arr.push(...this.handleSelection)
        this.goods_all_price = this.ruleForm.goods_arr.reduce((sum, item) => sum + (item.goods_num * (Number(item.goods_price))), 0);

      }
      this.dialogVisible = false
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('ruleForm', this.ruleForm);
          const plan_model = this.ruleForm.plan_model.join()

          const goods_arr = this.ruleForm.goods_arr.map(item => ({
            goods_id: item.goods_id,
            goods_name: item.goods_name,
            goods_price: item.goods_price,
            goods_num: item.goods_num,
          }));
          const interests_arr = this.ruleForm.interests_arr.map(item => ({
            interest_id: item.interest_id,
            interest_name: item.interest_name,
            interest_content: item.interest_content,
          }));
          const { plan_id } = this.ruleForm
          this.$alert(`是否确认${plan_id ? '编辑' : '新增'}？`, '确认弹窗', {
            confirmButtonText: '确定',
            callback: action => {
              if (action == 'confirm') {
                planSet({
                  ...this.ruleForm,
                  plan_model,
                  goods_arr,
                  interests_arr
                }).then(res => {
                  this.$refs[formName].resetFields();
                  this.$router.push({ path: '/membershipSystem/membershipProgramList' });
                })
              }
            }
          });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$router.push({ path: '/membershipSystem/membershipProgramList' });

    }
  }
}
</script>

<style scoped lang="scss">
.radio-item {
  margin-bottom: 15px;
}

.radio-text {
  margin-bottom: 5px;
  font-size: 14px;
  color: #666;
}

.form-footer {
  display: flex;
  justify-content: end;
  margin: 15px;
}
</style>
